module.exports = __webpack_public_path__ + "img/advertisement-puppy-pack.79031815.webp";